export const OWNERSHIP_STATUS_OPTIONS = [
  { value: 0, label: "Unencumbered" },
  { value: 1, label: "Owned/Encumbered" },
] as const;

export type OwnershipStatusValue = (typeof OWNERSHIP_STATUS_OPTIONS)[number]["value"];

export const normalizeOwnershipStatus = (
  value: number | string | null | undefined
): OwnershipStatusValue | "" => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "Unencumbered") return 0;
    if (trimmed === "OwnedEncumbered" || trimmed === "Owned/Encumbered") return 1;
    const n = parseInt(trimmed, 10);
    if (n === 0 || n === 1) return n;
    return "";
  }
  if (value === 0 || value === 1) return value;
  return "";
};

export const normalizeOperatorIdForForm = (
  value: unknown
): string => {
  if (value === null || value === undefined) return "";
  return String(value).trim().toLowerCase();
};

export const getOwnershipStatusLabel = (
  status?: number | null,
  labelFromApi?: string | null
): string => {
  if (labelFromApi?.trim()) return labelFromApi.trim();
  const normalized = normalizeOwnershipStatus(status ?? undefined);
  if (normalized === "") return "";
  return OWNERSHIP_STATUS_OPTIONS.find((o) => o.value === normalized)?.label ?? "";
};
